<template>
  <div class="container">
    <van-nav-bar title="抄表管理" left-text="" right-text="新增"
      left-arrow @click-left="onClickLeft" @click-right="changePage('')">
    </van-nav-bar>
    <div class="menu">
      <div class="menuitem" @click="showPicker(1)">
        {{statusName || '选择状态'}}
        <img class="icon" src="@/assets/img/sel_dc.png" />
      </div>
      <div class="menuitem" @click="showPicker(2)">
        {{communityName || '选择项目'}}
        <img class="icon" src="@/assets/img/sel_dc.png" />
      </div>
    </div>
    <van-popup v-model="showPopup" :close-on-click-overlay='false' round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        value-key="name"
        @cancel="onCancel"
        @confirm="onConfirm"
        @change="onChange"
      />
    </van-popup>
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="projectList.length > 0?'没有更多了':'暂无数据'"
      @load="onLoad"
    >
      <div class="list-box">
        <div class="list clearfix" @click="changePage(item)" :key="index" v-for="(item,index) in projectList">
          <div class="fl_left">
            <div class="mg10">项目：{{item.communityName}}</div>
            <div class="">时间：{{item.updateTime}}</div>
          </div>
          <div class="fl_right">
            <div class="mg10">
              <span class="" v-if="item.status == 1">{{item.statusDesc}}</span>
              <span class="col_o" v-if="item.status == 2">{{item.statusDesc}}</span>
              <span class="col_b" v-if="item.status == 3">{{item.statusDesc}}</span>
              <span class="col_g" v-if="item.status == 4">{{item.statusDesc}}</span>
              <span class="col_r" v-if="item.status == 5">{{item.statusDesc}}</span>
              <span class="col_r" v-if="item.status == 6">{{item.statusDesc}}</span>
              <img src="../../assets/img/sel_right.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </van-list>  

  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {NavBar,Icon,Image,Toast,Loading,Picker,Field,Popup,List,} from 'vant';
  export default {
    data() {
      return {
        allCount:0,
        pageIndex:1,
        pageSize:10,
        loading: false,
        finished: false,
        projectList:[],
        cityCode:'410100',
        status: undefined,
        communityId: undefined,
        communityName: '',
        statusName:'',
        showPopup: false,
        selIndex:'',
        columns:[],
        statusList:[
          {name:'全部',value: undefined},
          {name:'待抄表',value:1},
          {name:'待上传',value:2},
          {name:'待审核',value:3},
          {name:'已完成',value:4},
          {name:'已驳回',value:5},
          {name:'已逾期',value:6},
        ],
        cityList: [],
        communityList: [],
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Image.name]:Image,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,
      [Field.name]:Field,
      [Picker.name]:Picker,
      [Popup.name]:Popup,
      [List.name]:List
    },
    methods: {
      changePage(item){
        if(!item){
          this.$router.push({path: "uploadDegree.html"})
        }else{
          if(item.status == 1){
            this.$router.push({path: "uploadDegree.html",query:{communityId:item.communityId}})
          }else if(item.status == 2){
            this.$router.push({path: "uploadBill.html",query:{id:item.id}})
          }else if(item.status == 3){
            this.$router.push({path: "uploadResult.html",
            query:{active:1,communityName:item.communityName,fileNum:item.paymentCertificateList.length}})
          }else if(item.status == 4){
            this.$router.push({path: "payDetail.html",query:{id:item.id}})
          }else if(item.status == 5){
            this.$router.push({path: "uploadBill.html",query:{id:item.id}})
          }
        }
        
      },
      showPicker(type){
        this.selIndex = type;
        if(type == 1){
          this.showPopup = true;
          this.columns = this.statusList;
        }else{
          this.showPopup = true;
          this.columns = [
            // 第一列
            {
              values: this.cityList,
              defaultIndex: 0,
            },
            // 第二列
            {
              values: this.communityList,
              defaultIndex: 0,
            },
          ];
        }
      },
      onChange(picker,item, index) {
        if(this.selIndex == 2 && index == 0){
          this.cityCode = item[0].id;
          this.getCommunityList(picker);
        }
      },
      onCancel(){
        //取消
        if(this.selIndex == 1){
          this.status = undefined;
          this.statusName = '';
        }else{
          this.communityName = '';
          this.communityId = undefined;
        }
        this.showPopup = false;
        this.pageIndex = 1;
        this.getProjectList();
      },
      onConfirm(item) {
        if(this.selIndex == 1){
          this.status = item.value;
          this.statusName = item.name;
        }else{
          this.communityName = item[1].name;
          this.communityId = item[1].id;
        }
        this.pageIndex = 1;
        this.getProjectList();
        this.showPopup = false;
      },
      getCityList() {
        axios.get("/common/getcitylist?proviceId=410000").then((res)=>{
          this.cityList = res.data;
        })
      },
      getCommunityList(picker) {
        axios.post("/common/getcommunitylistbycitycode",{
          cityCode: this.cityCode,
        }).then((res)=>{
          if(res.data.length > 0){
            res.data.forEach(item=>{
              item.name = item.communityName
              item.id = item.communityId
            })
          }
          this.communityList = res.data;
          if(picker){
            picker.setColumnValues(1,res.data);
          }
          
        })
      },
      onLoad(){
        // 异步更新数据
        setTimeout(()=>{
          this.pageIndex++;
          this.getMoreList();
        },500)
      },
      getProjectList() {
        this.loading = true;
        axios.post("/meteruploaddegree/pagelist",{
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          filter: {
            communityId: this.communityId,
            status: this.status,
          }
        }).then((res)=>{
          // 加载状态结束
          this.loading = false;
          this.projectList = res.data.list;
          this.allCount = res.data.total;
          this.statistics = res.data.statistics;
        })
      },
      getMoreList() {
        axios.post("/meteruploaddegree/pagelist",{
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          filter: {
            communityId: this.communityId,
            status: this.status,
          }
        }).then((res)=>{
          this.projectList = this.projectList.concat(res.data.list);
          this.allCount = res.data.total;
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          if (this.pageIndex * this.pageSize >= this.allCount) {
            this.finished = true;
          }
        })
      },
      onClickLeft() {
        this.$router.replace({path: "home.html"});
      },
      onClickRight() {
      },
    },
    computed:{
    },
    created () {
      this.getCityList();
      this.getProjectList();
      this.getCommunityList();
    },
    mounted () {},
    destroyed () {}
  }
</script>
<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #F0F4F7}
  .container{
    width: 100%;height: 100%;letter-spacing:0px;background: #F0F4F7;
  }
  .list-box{
    width: 100%;
    color: #373737;
    .list{
      font-size: 14px;
      width: 100%;
      background: #fff;
      margin: 12px 0;
      padding: 12px;
      .fl_right{
        text-align: right;
        margin-top: 15px;
        img{
          width: 6px;
          margin-left: 8px;
          margin-bottom: 2px;
          vertical-align: middle;
        }
      }
    }
    .mg10{margin-bottom: 10px;}
    .bold{font-weight: bold;}
  }
  .menu{
    width: 100%;
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fff;
    .menuitem{
      width: 50%;
      display: inline-block;
      .icon{
        width: 10px;
        height: 6px;
        vertical-align: middle;
      }
    }
  }
</style>
